import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { Button, Typography } from "antd";
import { Calendar } from "lucide-react";
import meetingSuccessIcon from "../../assets/svg/icons/meeting-success.svg";
import LogoSvg from "../../assets/svg/logos/logo-black.svg";

const { Title, Text } = Typography;

const MeetingSuccessState = ({
  title,
  description,
  summaryTitle,
  summaryRows,
  status = "success",
  actions = [],
}) => {
  const isSuccess = status === "success";
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-px-4 tw-py-6 sm:tw-py-8">
      <div className="tw-mb-8">
        <NavLink to={isAuthenticated ? "/dashboard-view" : "/"} className="hover:tw-opacity-80 tw-transition-opacity">
          <img
            src={LogoSvg}
            alt="BeyondLeadz"
            style={{ height: "22px", width: "auto" }}
            className="tw-object-contain tw-cursor-pointer"
          />
        </NavLink>
      </div>

      <div className="tw-mb-8 tw-relative">
        <div className={`tw-absolute -tw-inset-3 tw-rounded-full tw-animate-pulse ${
          isSuccess ? "tw-bg-theme/5" : "tw-bg-red-500/5"
        }`} />
        <img
          src={meetingSuccessIcon}
          alt={isSuccess ? "Meeting success" : "Meeting status"}
          className="tw-relative tw-h-auto tw-w-[100px] tw-object-contain"
        />
      </div>

      <div className="tw-text-center">
        <Title
          level={3}
          className="!tw-mb-2 !tw-text-2xl sm:!tw-text-[26px] !tw-font-extrabold !tw-text-slate-800"
        >
          {title}
        </Title>
        <Text className="tw-text-sm sm:tw-text-base tw-text-slate-500">{description}</Text>
      </div>

      <div className="tw-mt-8 tw-w-full tw-max-w-[460px] tw-rounded-2xl tw-border tw-border-solid tw-border-slate-100 tw-bg-slate-50/40 tw-p-6">
        <div className="tw-mb-4 tw-text-xs tw-font-bold tw-text-slate-400 tw-uppercase tw-tracking-wider">
          {summaryTitle}
        </div>

        <div className="tw-grid tw-grid-cols-2 tw-gap-y-4 tw-text-sm">
          {summaryRows.map(({ label, value }) => (
            <React.Fragment key={label}>
              <div className="tw-pr-4 tw-text-slate-400 tw-font-semibold">{label}</div>
              <div className="tw-text-right tw-font-bold tw-text-slate-700">
                {value || "-"}
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>

      {actions.length ? (
        <div className="tw-mt-8 tw-flex tw-w-full tw-max-w-[560px] tw-flex-wrap tw-justify-center tw-gap-4">
          {actions.map((action) => (
            <Button
              key={action.label}
              type={action.variant === "primary" ? "primary" : "default"}
              icon={action.icon}
              onClick={action.onClick}
              className={
                action.variant === "primary"
                  ? "theme-btn !tw-h-[44px] !tw-rounded-xl !tw-px-6 !tw-text-sm !tw-font-bold tw-shadow-[0_8px_20px_rgba(93,68,255,0.25)] hover:tw-shadow-[0_12px_24px_rgba(93,68,255,0.35)] hover:tw-scale-[1.01] tw-transition-all tw-duration-300"
                  : "!tw-h-[44px] !tw-rounded-xl !tw-border-slate-200 !tw-bg-white !tw-px-6 !tw-text-sm !tw-font-bold !tw-text-slate-600 hover:!tw-border-slate-400 hover:!tw-text-slate-800 hover:tw-scale-[1.01] tw-transition-all tw-duration-200"
              }
            >
              {action.label}
            </Button>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export const defaultCalendarAction = {
  icon: <Calendar size={16} />,
  label: "View in Calendar",
  variant: "primary",
};

export default MeetingSuccessState;
